import axios from 'axios';
import { Toast } from 'vant';
import { wxlogin, getMobileToken } from '@/api/base';
import { getParams } from '@/utils/index';
import Cookies from 'js-cookie';
import store from '../store';
import router from '../router';
// 创建axios实例
const service = axios.create({
  // baseURL: process.env.VUE_APP_SAAS_BASE_API, // api的base_url
  // baseURL: 'https://yichen.smartrecorder.xyz', //正式
  baseURL: 'https://ycat.smartrecorder.xyz', //测试
  timeout: 250000 * 2, // 请求超时时间
  // withCredentials: true,
  headers: {
    // ZY_SHOP_ID: '1130319276834578432'
    // ZY_WX_ID: 'wxf89f3280cb789612',
    // USER_TOKEN_HEAD:''
    // ZY_WX_ID: 'wxf89f3280cb789612'
  }, // 表明该请求来自于哪一个系统
});
// request拦截器
service.interceptors.request.use(
  config => {
    // Toast.loading({
    //   message: '当前访问人数过多，加载中请稍后...',
    //   forbidClick: true,
    //   duration:0,
    // });
    // 随机数
    // config.headers['ZY_TRANSID'] = Math.random()
    //   .toString(36)
    //   .substr(2);
    // token
    // if (store.state.app.token) {
    //   config.headers['USER_TOKEN_HEAD'] = store.state.app.token
    //   // config.headers['X_AUTH_MANAGER_ID'] = store.getters.user.id
    // }
    let extra_user_token = window.localStorage.getItem('extra_user_token');
    if (
      extra_user_token &&
      config.url.indexOf('weoauth/oauthInfo') == -1 &&
      config.url.indexOf('weixin') == -1 &&
      config.url.indexOf('intiInfo') == -1
    ) {
      // if (window.extra_user_token && config.url.indexOf('weoauth/oauthInfo')==-1 && config.url.indexOf('intiInfo')==-1) {
      // config.headers['token'] = window.extra_user_token;
      config.headers['Authorization'] = 'Bearer ' + extra_user_token; // 让每个请求携带自定义token 请根据实际情况自行修改
      // config.headers['X_AUTH_MANAGER_ID'] = store.getters.user.id
    }

    if (window.localStorage.getItem('sessionKey') && config.url.indexOf('weixin') != -1) {
      // config.headers['token'] = window.extra_user_token;
      config.headers['third-session'] = window.localStorage.getItem('sessionKey'); // 让每个请求携带自定义token 请根据实际情况自行修改
      // config.headers['X_AUTH_MANAGER_ID'] = store.getters.user.id
    }
    // if (window.extra_shop_id) {
    //   config.data.shopId = window.extra_shop_id;
    // }
    // config.headers['X_AUTH_MANAGER_ID'] = Cookies.get('zy-live-paas-web-token');
    // config.headers['ZY_SHOP_ID'] = Cookies.get('zy-live-paas-web-shopId');
    // shopId
    if (window.localStorage.getItem('openId') && config.method == 'get') {
      if (config.params) {
        config.params.openId = window.localStorage.getItem('openId');
      }
      // if(config.params){config.params.token= window.localStorage.getItem('extra_user_token')}
    }
    // contentType
    if (config.method === 'post' || config.method == 'put') {
      if (config.headertype) {
        config.headers['Content-Type'] = config.headertype;
      } else {
        config.headers['Content-Type'] = 'application/json';
      }
      if (config.data) {
        let openId = window.localStorage.getItem('openId') || null;
        if (config.url.indexOf('upload') == -1) {
          config.data.openId = openId;
        }
        // if(config.headers['Content-Type']!="multipart/form-data" || config.headers['Content-type']!="multipart/form-data"){
        //   config.data = JSON.stringify(config.data);
        // }
      }
    }
    return config;
  },
  error => {
    // Do something with request error
    return Promise.reject(error);
  },
);

// respone拦截器
service.interceptors.response.use(
  response => {
    if (response.data.code === 200 || response.data.code === 0) {
      Toast.clear();
      return response.data;
    }
    if (response.data.code === 60001 || response.data.code === 60002) {
      // let href =encodeURIComponent(encodeURIComponent(window.location.href))
      let href = encodeURIComponent(window.location.href);

      // next(`/login?backUrl=${href}`)
      wxlogin({ backUrl: href }).then(res => {
        window.location.href = res.data;
      });
      return;
    }

    if (response.data.code === 401) {
      const config = response.config;
      // 防止刷新 token 后仍 401 导致的无限重试
      if (config._retried) {
        Toast.clear();
        return Promise.reject(response.data);
      }
      config._retried = true;
      // 刷新 token 后透明地重试原请求，避免整页 reload（修复首次登录刷新页面问题）
      return getMobileToken(getParams()).then(res => {
        window.localStorage.setItem('extra_user_token', res.token);
        window.extra_user_token = res.token;
        // POST/PUT 的 data 在首次发送时已被序列化为字符串，重试前需还原为对象，
        // 否则请求拦截器给 data 追加 openId 时会在字符串上赋值而报错
        if (typeof config.data === 'string') {
          try {
            config.data = JSON.parse(config.data);
          } catch (e) {
            // 非 JSON 数据（如表单/上传）保持原样
          }
        }
        return service(config);
      });
    }

    if (response.data.code === 1008 || response.data.code === 1007) {
      Toast.clear();
      return Promise.reject(response.data);
    }
    // // 未登录
    // if (response.data.code === 9201001) {
    //   Toast({ message: response.data.message, type: 'error' })
    //   /* 登录超时 */
    //   wx.miniProgram.navigateTo({
    //     url: ``
    //   })
    //   return Promise.reject(response.data)
    // }
    Toast(response.data.msg);

    return Promise.reject(response.data);
  },
  error => {
    // Toast('网络请求失败, 请检查网络连接后重试');

    return Promise.reject(error);
  },
);

export default service;
